import { render, staticRenderFns } from "./Divulgation.vue?vue&type=template&id=706de994&scoped=true&"
import script from "./Divulgation.vue?vue&type=script&lang=js&"
export * from "./Divulgation.vue?vue&type=script&lang=js&"
import style0 from "./Divulgation.vue?vue&type=style&index=0&id=706de994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706de994",
  null
  
)

export default component.exports